module.exports = __webpack_public_path__ + "img/home.669f8710.png";